<template>
  <div
    id="app"
    v-track-content:detail="{
      tab_name: 'shanghaieye',
    }"
  >
    <!-- <keep-alive exclude="Detials">  
    </keep-alive>-->
    <Layout v-if="this.$route.path !== '/poster'"></Layout>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>
<script>
import Layout from "@/components/common/layout/Layout.vue";
import router from "./router";

// const showHeader= true;
export default {
  name: "",
  components: {
    Layout,
  },
  data() {
    return {
      showHeader: true,
    };
  },
  mounted() {
    // 禁止在顶部下拉头部出现白屏问题兼容ios 11.3
    // document.body.addEventListener(
    //   "touchmove",
    //   e => {
    //     e.preventDefault();
    //   },
    //   { passive: false }
    // );
    this.postName();
  },
  methods: {
    postName() {
      var url = window.location.href;
      // console.log("url");

      var content = url.match(/([^\/]+)/g);
      // console.log(content);

      if (content.length == 3 && content[2].indexOf("-") != -1) {
        // console.log("触发了");
        const str = content[2];
        var obj = {};
        obj.postName = str;
        $.ajax({
          url: `${process.env.VUE_APP_BASE_API}/wpindex/postname`,
          type: "POST",
          contentType: "application/json",
          data: JSON.stringify(obj),
          success: function(res) {
            // console.log(res,'1111111');
            if (res.data) {
              window.location.href =
                "https://www.shanghaieye.cn/detail?postId=" + res.data;
            } else {
            }
          },
          error: function(res) {
            console.log(res);
          },
        });
      }
    },
  },
};
// router.beforeEach((to, from, next) => {
//   if(to.path == '/poster'){
//     showHeader = false;
//   }
//   console.log(Vue.showHeader,'showHeader')
//   // console.log(from)
//   next()
// })
</script>

<style lang="less">
@import url("~@/assets/css/base.css");
// .mt-h {
//   margin-top: 1.3rem;
// }
#app {
  width: 100%;
  overflow-x: hidden;
  // a
}
.img-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  &:hover {
    background: rgba(0, 0, 0, 0.2);
  }
}

.showLoading {
  font-size: 18px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #999999;
}
</style>
